import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useDataChange, useDataSubmit } from 'Simple/Data.js'

export function useOnIgnoreMatches(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'appointment_overlay',
  })

  return function onIgnoreMatches() {
    return submit({ type: 'schedule' })
  }
}

export function useOnUseSelectedLead(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'appointment_overlay',
  })

  return function onUseSelectedLead(value) {
    return submit({ type: 'schedule', lead_id: value.id })
  }
}

export function useOnUseSelectedPatient(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let change = useDataChange({
    context: 'appointment_overlay',
    viewPath: props.viewPath,
  })

  return function onUseSelectedPatient(value) {
    change(next => {
      next.patient_id = value.id
      next.patient_option = 'existing'
      next.skip_appointment_reset = true
    })

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}

export function useOnUseSelectedPerson(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'appointment_overlay',
  })

  return async function onUseSelectedPerson(value) {
    return submit({ type: 'createPatient', person_id: value.id })
  }
}
